import React from 'react';
/* eslint-disable-next-line */
import classNames from 'classnames';
import { Card, CardContent, makeStyles } from '@material-ui/core';
import { FuseAnimate } from '@fuse';

const useStyles = makeStyles((theme) => ({
    root: {
        height: '92.5vh',
        width: '100%',
        background: theme.palette.primary.default,
        color: theme.palette.primary.contrastText,
    },
}));

const AnimatedCard = ({ children }) => {
    const classes = useStyles();

    return (
        <>
            <div className={classNames(classes.root, 'flex flex-col flex-auto flex-no-shrink items-center justify-center p-32')}>
                <div className="flex flex-col items-center justify-center w-full h-full">
                    <FuseAnimate animation="transition.expandIn" delay={200}>
                        <Card className={classNames(classes.root)}>
                            <CardContent className="flex flex-col items-center justify-center p-32 h-full">{children}</CardContent>
                        </Card>
                    </FuseAnimate>
                </div>
            </div>
        </>
    );
};

export default AnimatedCard;
